import { PvBrLayout, PvBrHome, urlBuilder } from 'previc-dsgov';

import { useLocation, useNavigate } from 'react-router-dom';
import { keycloakService } from './auth/keycloakService';

import './App.scss'

import AppRoutes from './routes/app.routes';
import { AntdGlobalProvider } from './config/AntdGlobalProvider';
import { carregarDadosUsuario } from './auth/entidadeUsuario';
import { getItensDeMenu } from './config/Menu';


const App = () => {
	const navigate = useNavigate();
	const location = useLocation();

    const raizComBase = `${window.location.protocol}//${window.location.host}`;
	const paginaHome = raizComBase + '/home';
	const loginLink = urlBuilder.loginBuilder(
		process.env.REACT_APP_KEYCLOAK_URL ??'', 
		process.env.REACT_APP_KEYCLOAK_REALM ??'', 
		process.env.REACT_APP_KEYCLOAK_CLIENTID ??'', 
		paginaHome);
	const logoutLink = urlBuilder.logoutBuilder(
		process.env.REACT_APP_KEYCLOAK_URL ??'', 
		process.env.REACT_APP_KEYCLOAK_REALM ??'');

    async function carregarInicial(){
      await carregarDadosUsuario().catch((error) => {
		//console.log(error)
		navigate("/error", { state: error });
        return [];
      });
	  
      return getItensDeMenu();
    }

	if (window.location.href === raizComBase+'/'){
		return (
			<PvBrHome titulo={'CAND PREVIC'} subtitulo={'Cadastro Nacional de Dirigentes'} loginLink={loginLink} />
		)
	}
	const redirectUri = window.location.href;

    return (<>
		<PvBrLayout loginLink={loginLink} navigate={navigate} location={location}
			titulo={'CAND PREVIC'}  subtitulo={'Cadastro Nacional de Dirigentes'} 
			logoutLink={logoutLink} getMenuItems={carregarInicial} keycloak={keycloakService} redirectUri={redirectUri} >
			<AntdGlobalProvider>
				<AppRoutes />
			</AntdGlobalProvider>
		</PvBrLayout>

    </>);

};

export default App;
